import React, { useMemo } from 'react';
import TableContainer from "../../Components/Common/DataTables/TableContainer";
import ErrorBoundary from "../../Components/Common/ErrorBoundary";

const Vendorlistproducts = ({ listdata, onAdd }) => {

    const columns = useMemo(() => [
        {
            header: "Select Vendor Name",
            accessorKey: "business_name",
            enableSorting: true,
            enableColumnFilter: false,
        },
        {
            header: "Shipping days",
            accessorKey: "shipping_days",
            enableSorting: true,
            enableColumnFilter: false,
        },
        {
            header: "Price",
            accessorKey: "selling_price",
            enableSorting: true,
            enableColumnFilter: false,
        },
        {
            header: "Stock",
            accessorKey: "inventory",
            enableSorting: false,
            enableColumnFilter: false,
            cell: ({ row }) => (
                <div>
                    {row.original.inventory > 0 ? (
                        row.original.inventory
                    ) : (
                        <span className="badge bg-danger-subtle text-danger text-uppercase">
                            Out of Stock
                        </span>
                    )}
                </div>
            ),
        },
        // {
        //     header: "Select",
        //     accessorKey: "select",
        //     enableColumnFilter: false,
        //     cell: ({ row }) => (
        //         <input
        //             type="radio"
        //             name="vendorSelect"
        //             onChange={() => onAdd(row.original)}
        //         />
        //     ),
        // },

        {
            header: "Action",
            accessorKey: "actions",
            enableColumnFilter: false,
            cell: ({ row }) => (
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => onAdd(row.original)}
                >
                    <i class="ri-add-circle-line"></i>
                </button>
            ),
        }
    ], [onAdd]);

    return (
        <div className="mt-4">
            <ErrorBoundary fallback={<div>Oops! Something went wrong</div>}>
                <TableContainer
                    perPageNotRequired
                    columns={columns}
                    data={listdata}
                    customPageSize={process.env.REACT_APP_PER_PAGE}
                    disableSearch
                    disableNavigation
                />
            </ErrorBoundary>
        </div>
    );
};

export default Vendorlistproducts;
